// Controle de acesso da página "Leads do Type" (conferência type × CRM, 30/10/2026).
// Regra: admin ou admin master dos grupos com funil no type (Nascimento Martins 9184,
// Buchele Rodrigues 9180, Thiago Castro 9189). O backend (/leads_type) repete a lista.
// `id_grupo` no localStorage = cliente (grupo); `id_cliente` = time (naming do CRM).
export const LEADS_TYPE_GRUPOS: string[] = [];

export const canViewLeadsType = (): boolean =>
  LEADS_TYPE_GRUPOS.includes(localStorage.getItem("id_grupo") || "") &&
  (localStorage.getItem("isAdmin") === "true" || localStorage.getItem("isAdminMaster") === "true");
